module.exports = __webpack_public_path__ + "static/media/logo-emociones.63b8cac3.png";